export default __webpack_public_path__ + "static/media/insights-splash-mobile.1a977e38.png";